// Map display names to their correct camelCase keys for built-in marker types
export const BUILT_IN_TYPE_KEYS: Record<string, string> = {
  'Fire Hydrant': 'fireHydrant',
  Pothole: 'pothole',
  'Road Block': 'roadBlock',
  Flooding: 'flooding',
  'Limited Visibility': 'limitedVisibility',
  'Dead Animal': 'deadAnimal',
  'Down Wires': 'downWires',
  'Down Pole': 'downPole',
  Debris: 'debris',
  'Open Manhole': 'openManhole',
  'Road Work': 'roadWork',
};

// Get the correct key for a marker type - use built-in mapping if available, otherwise lowercase
export const getMarkerTypeKey = (name: string): string => {
  return BUILT_IN_TYPE_KEYS[name] || name.toLowerCase().replace(/\s+/g, '');
};
